import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import Field from '../../../../components/Form/Field'
import PhoneInput from '../../../../components/Form/PhoneInput'
import FieldLabelWrapper from '../../../../features/components/Form/FieldLabelWrapper'

import { getCurrentUserSelector } from '../../../../modules/selectors/app'
import { choicesCountriesSelector } from '../../../../modules/selectors/choices'

import { COUNTRY } from '../../../../pages/Settings/EditProfile/UserProfileContent/fields'
import { FIRST_NAME, LAST_NAME, EMAIL, PHONE_NUMBER } from '../../fields'

import useStyles from './styles'

const RepresentativeFormFields = ({ formik }) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const user = useSelector(getCurrentUserSelector)
  const countries = useSelector(choicesCountriesSelector)

  const userCountry = user[COUNTRY]
  const userCountryIso2 = countries.find(item => item.id === userCountry)?.iso2?.toLowerCase()

  return (
    <>
      <div className={classes.row}>
        <FieldLabelWrapper label={t('First Name')}>
          <Field placeholder={t('First Name')} formik={formik} name={FIRST_NAME} enableReinitialize />
        </FieldLabelWrapper>
        <FieldLabelWrapper label={t('Last Name')}>
          <Field placeholder={t('Last Name')} formik={formik} name={LAST_NAME} enableReinitialize />
        </FieldLabelWrapper>
      </div>
      <FieldLabelWrapper label={t('Email')}>
        <Field placeholder={t('Email')} formik={formik} name={EMAIL} enableReinitialize />
      </FieldLabelWrapper>
      <FieldLabelWrapper label={t('Phone')}>
        <PhoneInput
          name={PHONE_NUMBER}
          formik={formik}
          initialValue={formik.values[PHONE_NUMBER]}
          country={userCountryIso2}
        />
      </FieldLabelWrapper>
    </>
  )
}

RepresentativeFormFields.propTypes = {
  formik: PropTypes.object.isRequired
}

export default RepresentativeFormFields
